<template>
    <div>
        <div v-if="!loading.display">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Quotation<strong> #{{quotation.code}}</strong></h4>
                    <p class="subtitle-1">Display Quotation</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn
                        block 
                        color="primary"
                        @click="openQuotationPrintDialog({id: quotation?quotation.id: null})">
                        <v-icon left>mdi-printer</v-icon>
                        Print
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn
                        v-if="hasPermission(perm.quotation.update)" 
                        block
                        depressed 
                        @click="navgiateToEdit({id: quotation?quotation.id: null})"
                    >
                        <v-icon left>mdi-pencil</v-icon>
                        edit
                    </v-btn>
                </v-col>
                <v-col md="3">
                    <v-btn block color="red--text" depressed   @click="handleDelete" v-if="hasPermission(perm.quotation.delete)" :loading="loading.delete">
                        <v-icon left>mdi-delete</v-icon>
                        delete
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-if="loading.data" no-gutters>
                <v-col >
                    <div class="text-center" >
                        <v-progress-circular indeterminate>
                        </v-progress-circular>
                    </div>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-simple-table dense>
                                <tbody>
                                    <tr>
                                        <th>{{ $t('code') }}</th>
                                        <td colspan="3">{{ quotation?quotation.code: "" }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('date') }}</th>
                                        <td>{{ quotation?quotation.date: "" }} </td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('validity_date') }}</th>
                                        <td>{{ quotation?quotation.validity_date: "" }} </td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('site') }}</th>
                                        <td>{{ quotation?quotation.site: "" }} </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-simple-table dense>
                                <tbody>
                                    <tr>
                                        <th>{{ $t('customer') }} </th>
                                        <td>{{ customer?customer.name: "" }}
                                            <span>
                                                <v-btn icon x-small @click="openCustomerDisplayDialog({id: customer.id})">
                                                    <v-icon>mdi-magnify</v-icon>
                                                </v-btn>
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('code') }}</th>
                                        <td>{{ customer?customer.code: "" }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('phone') }} </th>
                                        <td>{{ customer?customer.phone: "" }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('address') }}</th>
                                        <td>{{ customer?customer.address: "" }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                    <br>
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th class="d-none d-md-table-cell">#</th>
                                <th>{{ $t('item') }}</th>
                                <th>{{ $t('quantity') }}</th>
                                <th class="d-none d-md-table-cell">{{ $t('unit_measure') }}</th>
                                <th>{{ $t('price') }}</th>
                                <th class="d-none d-md-table-cell">{{ $t('total') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(itemLine, index) in quotation.lines" :key="index">
                                <td class="d-none d-md-table-cell">{{ index + 1 }}</td>
                                <td>{{ itemLine.item }}</td>
                                <td>{{ itemLine.quantity }}</td>
                                <td class="d-none d-md-table-cell">{{ itemLine.measure_unit }}</td>
                                <td>{{ formatPrice(itemLine.price) }}</td>
                                <td class="d-none d-md-table-cell">{{ formatPrice(itemLine.quantity * itemLine.price) }}</td>
                            </tr>
                            <tr>
                                <td class="d-none d-md-table-cell"></td>
                                <td></td>
                                <td></td>
                                <td class="d-none d-md-table-cell"></td>
                                <td><span class="d-none d-md-table-cell">{{ $t('total') }}</span></td>
                                <td class="d-none d-md-table-cell">{{ formatPrice(quotation.total) }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <v-simple-table dense v-if="quotation.remarks">
                        <thead>
                            <tr>
                                <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{quotation.remarks}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </div>
       <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex flex-row">
                    <v-skeleton-loader type="button" class="my-2 mx-2"/>
                    <v-skeleton-loader type="button" class="my-2 mx-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>

       </div>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
        <RetryDialog ref="retryDialog" @submit="onRetryDialogSubmit" />
        <QuotationPrintDialog ref="quotationPrintDialog" />
        <CustomerDisplayDialog ref="customerDisplayDialog"/>
    </div>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions } from 'vuex';
import { formatMoney } from 'accounting';
import { getCustomer } from '../../services/sales/customer';
import RetryDialog from '@/components/common/RetryDialog';
import QuotationPrintDialog from '@/components/Sales/QuotationPrintDialog';
import CustomerDisplayDialog from './../../components/Sales/CustomerDisplayDialog.vue';
import authorize from '../../utils/authorize';

export default {
    name: "QuotationDisplayView",
    components: {
        RetryDialog,
        QuotationPrintDialog,
        CustomerDisplayDialog
    },
    data() {
        return {
            display: null,
            openParams: null,
            customer: null,
            loading: {
                display: false,
                delete: false
            },
            perm: permissions,
            id: null,
            quotation: null,
            alert: {
                title: "",
                content: "",
                callback: null
            },
        }
    },
    methods: {
        ...mapActions("sales/quotation", ["fetchQuotation", "removeQuotation"]),
        ...mapActions({
            snackbar: "ui/snackbar/show"
        }),
        hasPermission(code) {
            return authorize(code)
        },
        getAsync() {
            this.loading.display = true;
            this.openDataFetch();
        },
        formatPrice(amount) {
            return formatMoney(amount, "SDG ", 2);
        },
        async openDataFetch() {
            try {
                await this.fetchQuotation(this.id).then(response => {
                    this.quotation = response.data
                });
                let customerResponse = await getCustomer(this.quotation.customer_id);
                this.customer = customerResponse.data;
                this.loading.display = false;
            } catch (error) {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({text: message, color: "error"});
                this.$refs.retryDialog.open({
                    target: "openDataFetch",
                    message
                });
                this.loading.display = false;
            }
        },
        openQuotationPrintDialog(params) {
            this.$refs.quotationPrintDialog.open(params);
        },
        onRetryDialogSubmit(params) {
            if (params.target == "openDataFetch") {
                if (params.retry) this.openDataFetch();
            }
        },
        openCustomerDisplayDialog({id}) {
            this.$refs.customerDisplayDialog.open({id})
        },
        navgiateToEdit(id) {
            this.$router.push({ name: "QuotationEdit",  id  })
        },
        handleMouseOver(e) {
            e.target.style.transform = "scale(1.5)"
        },
        handleMouseLefe(e) {
            e.target.style.transform = "scale(1)"
        },
        handleDelete() {
            this.alert = {
                content: "Are you sure you want to delete",
                value: true,
                callback: this.remove
            }
        },
        remove() {
            this.loading.delete = true;
            this.removeQuotation({id: this.id}).then(() => {
                this.snackbar({ color: "success", text: "Quotation Delete Success"});
                this.$router.push({ name: "Quotations"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ color: "error", text: message});
            }).finally(() => {
                this.loading.delete = false
            })
            
        }
    },
    created() {
        this.quotation = {}
        this.id = this.$route.params.id;
        this.getAsync();
    }
}
</script>

<style>

</style>